import { Container } from "@mui/system";
import CustomSection from "components/CustomSection";
import about_us from "assets/static/landing/O QUE É - 535 × 529.png";
import { Typography, Box } from "@mui/material";
import team from "assets/static/landing/POR QUE - 531 × 225.png";
import mission from "assets/static/landing/QUEM SOMOS - 531 × 224.png";
import do_img from "assets/static/landing/O QUE - 531 × 226.png";
import styles from "./styles.module.css";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import ScrollTransition from "components/ScrollTransition";

const SobreNos = ({ on_top, dark_mode }) => {
  return (
    <CustomSection
      style={{
        overflow: "hidden",
        position: "relative",
      }}
      id="quem-somos"
      bg_color="var(--background-color1)"
    >
      <Container
        maxWidth="xl"
        sx={{
          width: "100vw",
          minHeight: "100vh",
          padding: "2rem 0",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: {
              xs: "column",
              sm: "column",
              md: "row",
            },
            gap: "2rem",
          }}
        >
          <Box
            sx={{
              width: {
                xs: "100%",
                sm: "100%",
                md: "60%",
              },
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              textAlign: {
                xs: "center",
                sm: "center",
                md: "left",
              },
              alignItems: "flex-start",
              margin: {
                xs: "auto auto 0 auto",
                sm: "auto auto 0 auto",
                md: "auto",
              },
            }}
          >
            <Box
              sx={{
                borderLeft: {
                  xs: "none",
                },
                padding: "1rem",
                paddingLeft: {
                  xs: "0",
                  sm: "2rem",
                  md: "2rem",
                },
                display: "flex",
                flexDirection: "column",
                gap: "1rem",
              }}
            >
              <ScrollTransition>
                <Typography
                  variant="h2"
                  sx={{
                    fontWeight: "bold",
                    fontSize: {
                      xs: "2rem",
                      sm: "2.8rem",
                      md: "3.8rem",
                    },
                  }}
                >
                  O que é o i<span style={{ color: "#EEB547" }}>G</span>ooB?
                  {/* <span style={{ color: "var(--accent-color3)" }}>S</span>CIENCE */}
                </Typography>
              </ScrollTransition>

              <ScrollTransition
                sx={{
                  maxWidth: {
                    xs: "100%",
                    sm: "100%",
                    md: "80%",
                  },
                  padding: {
                    xs: "0 2rem",
                    sm: "0 2rem",
                    md: "0",
                  },
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "normal",
                    fontSize: {
                      xs: "1.2rem",
                      sm: "1.3rem",
                      md: "1.4rem",
                    },
                    lineHeight: "2rem",
                    textAlign: 'justify',
                  }}
                >
                  Com poucos cliques, é possível encontrar cimento, areia, blocos, concreto e pisos, entre
tantos outros materiais essenciais para uma construção. Além disso, o iGooB também
atende às demandas do dia a dia, oferecendo chuveiros, torneiras, lâmpadas, ventiladores,
mobílias e uma ampla variedade de itens voltados à construção civil, tudo com praticidade,
segurança e rapidez.
<br/>
<br/>

Mais do que um marketplace, o iGooB é uma plataforma inteligente que une tecnologia,
praticidade e propósito: tornar o processo de compra e venda no setor da construção civil
mais ágil, acessível e eficiente.
                </Typography>
              </ScrollTransition>
            </Box>
          </Box>
          <Box
            sx={{
              width: "40%",
              display: {
                xs: "none",
                sm: "none",
                md: "flex",
              },
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "flex-start",
              maxWidth: "28rem",
              margin: {
                xs: "0 auto auto auto",
                sm: "0 auto auto auto",
                md: "auto",
              },
            }}
          >
            <ScrollTransition>
              <img
                src={about_us}
                alt="Sobre nós"
                style={{
                  width: "120%",
                  position: "relative",
                  top: "5rem",
                  right: "20%",
                  zIndex: "0",
                  background: !dark_mode && `radial-gradient(circle, rgba(124, 50, 225, 1) -50%, rgba(255,255,255,0) 70%)`,
                }}
              />
            </ScrollTransition>
          </Box>
        </Box>

        <Box
          sx={{
            display: {
              xs: "flex",
              sm: "flex",
              md: "none",
            },
            flexDirection: "column",
          }}
        >
          <ScrollTransition>
            <img
              src={about_us}
              alt="Sobre nós"
              style={{
                width: "100%",
                position: "relative",
                top: "5rem",
                zIndex: "0",
                margin: "auto",
                WebkitFilter: `drop-shadow(0px 0px 198px rgba(124, 50, 225, 1))`,
                filter: `drop-shadow(0px 0px 198px rgba(124, 50, 225, 1))`,
              }}
            />
          </ScrollTransition>
        </Box>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "4rem 2rem",
            padding: "8rem 1rem 4rem 1rem",
          }}
        >
          <ServiceCard
            title="QUEM SOMOS?"
            description="Somos o iGooB, um aplicativo que nasceu da experiência real de quem vive a construção
civil no dia a dia. Criado por um engenheiro que transformou uma dor em solução,
conectamos pessoas, obras e fornecedores em um só lugar — com tecnologia, praticidade
e confiança."
            image={mission}
            speed={15}
          />
          <ServiceCard
            title="POR QUE NOS ESCOLHER?"
            description="Porque entendemos o que é construir. Sabemos o valor do tempo, da organização e da
agilidade em cada projeto. No iGooB, reunimos tudo o que você precisa em poucos cliques
— de materiais básicos a itens de acabamento, com segurança e facilidade."
            image={team}
            speed={30}
          />
          <ServiceCard
            title="O QUE NÓS FAZEMOS?"
            description="Facilitamos a compra e venda de materiais de construção, conectando quem precisa
comprar com quem tem para vender. No iGooB, você encontra tudo o que precisa para sua
obra ou reforma, de forma rápida, inteligente e sem complicação."
            image={do_img}
            speed={45}
          />
        </div>
      </Container>
    </CustomSection>
  );
};

export default SobreNos;

const ServiceCard = ({ title, description, image, speed }) => {
  return (
    <Box
      className={`${styles.serviceCard} Transition-1`}
      sx={{
        width: "24rem",
        flexGrow: 1,
        padding: "0.8rem",
        borderRadius: "0.8rem",
        position: "relative",
        // transition: "all 0.3s",
        cursor: "pointer",
        "&:hover": {
          // backgroundColor: "var(--background-0)",
          transform: "translateY(-1rem)",
          boxShadow: "0 1rem var(--background-2)",
        },
        perspective: "1500px",
      }}
    >
      {/* <div className={`${styles.cardFlipEffect} Transition-1`} /> */}
      <img
        src={image}
        alt="Ícone do cartão"
        style={{
          width: "100%",
          height: "14rem",
          marginBottom: "1rem",
          objectFit: "cover",
          borderRadius: "0.8rem 0.8rem 0 0",
          WebkitMaskImage:
            "-webkit-gradient(linear, left top, left bottom, from(rgba(0,0,0,1)), to(rgba(0,0,0,0)))",
          maskImage: "linear-gradient(to bottom, rgba(0,0,0,1), rgba(0,0,0,0))",
          zIndex: 2,
        }}
      />
      <h3
        style={{
          fontSize: "1.6rem",
          fontWeight: "bold",
          color: "var(--text-main-2)",
          position: "relative",
          width: "max-content",
          zIndex: 2,
          margin: "0 auto",
          bottom: "3rem",
        }}
      >
        {title}
      </h3>
      <p
        style={{
          fontSize: "1.2rem",
          fontWeight: "normal",
          color: "var(--text-main-1)",
          textAlign: "justify",
          position: "relative",
          bottom: "2rem",
          zIndex: 2,
        }}
      >
        {description}
      </p>
    </Box>
  );
};
